import jwtDecode from 'jwt-decode';

const JWT_TOKEN_TOLERANCE_SECONDS = 2 * 60;

const getCookie = (name) => {
    const prefix = `${name}=`;
    const row = document.cookie.split('; ').find((r) => r.startsWith(prefix));
    if (!row) {
        return undefined;
    }
    const value = row.slice(prefix.length);
    try {
        return decodeURIComponent(value);
    } catch {
        return value;
    }
};

export const getIdToken = () => getCookie('idToken');
export const getRefreshToken = () => getCookie('refreshToken');

export const isAuthenticated = () => Boolean(getIdToken());

export const getTokenPayload = (token) => {
    try {
        return jwtDecode(token);
    } catch {
        return null;
    }
};

const isTokenExpired = (token) => {
    const payload = getTokenPayload(token);
    if (!payload?.exp) {
        return true;
    }
    const expiresAt = payload.exp - JWT_TOKEN_TOLERANCE_SECONDS;
    return Date.now() / 1000 >= expiresAt;
};

export const getValidIdToken = async (refreshTokenFn) => {
    let idToken = getIdToken();
    if (!idToken) {
        return null;
    }

    if (isTokenExpired(idToken)) {
        const refreshToken = getRefreshToken();
        if (!refreshToken || !refreshTokenFn) {
            return null;
        }
        idToken = await refreshTokenFn(refreshToken);
    }

    return idToken;
};
